var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal in",
      class: { "fade modal-open": _vm.isModalOpen },
      on: {
        click: function($event) {
          if ($event.target !== $event.currentTarget) {
            return null
          }
          $event.stopPropagation()
          return _vm.close($event)
        }
      }
    },
    [
      _c("div", { staticClass: "modal-dialog" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c(
            "div",
            { staticClass: "modal__header", class: _vm.headerClasses },
            [_c("h2", [_vm._v("Fuel Promo Terms and Conditions")])]
          ),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "modal__footer" }, [
            _c(
              "div",
              {
                staticClass: "modal__send-btn",
                on: {
                  click: function($event) {
                    if ($event.target !== $event.currentTarget) {
                      return null
                    }
                    $event.stopPropagation()
                    return _vm.closeModal($event)
                  }
                }
              },
              [_vm._v("Close")]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-body" }, [
      _c("p", [
        _vm._v(
          "The terms and conditions of Fuel Promo Funds are subject to change by Fuel Medical in its sole discretion. Fuel Promo Funds are designed to assist eligible participants with Fuel Digital Services and Audiology Growth Services including but not limited to Website Design, Search Engine Optimization, Search Engine Marketing, Social Marketing, Reputation Management, Email Marketing, Database and New Patient Print Marketing promoting Audiology and other Audiology Growth Services approved by Fuel Medical.  Fuel Medical may also apply accrued Fuel Promo Funds against any open balances with Fuel Medical. Eligible participants agree to maintain an active business relationship with Fuel Medical and to affiliate all of their hearing aid accounts with Fuel Medical’s manufacturing partners. Fuel Medical shall determine, in its sole discretion, the eligibility of a participant and whether or not a business relationship is active. Fuel Promo Funds are accrued on a rolling 18 month basis. Any unused Fuel Promo Funds accumulated longer than 18 months will be forfeited. Failure to have an active business relationship with Fuel Medical or any action to terminate a relationship with Fuel Medical will immediately forfeit any and all accrued Fuel Promo Funds. Fuel Promo Funds will not be accrued on any hearing instruments purchased for fitting under any state or federal government reimbursement program or other third-party payer program."
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }